/* eslint-disable */
import { createRouter, createWebHistory } from 'vue-router'
import isMobile from '../assets/isMobile'



const routes = [
  {
		path: '/',
		name: 'index',
		component: () => import('../view/index.vue'), 
		meta: {
		  title: '首页'
		}
		 
  },
  {
        path: '/m_index', // 移动端首页
        name: 'wb_index',
        component: () => import('../view/web/index.vue'), 
	    meta: {
	     title: '移动端首页'
	    }
  },
 
  {
  		path: '/page/:catrage_id',
  		name: 'page',
  		component: () => import('../view/page.vue'), 
  		meta: {
  		  title: '概况'
  		}
  		 
  },
 
  {
  		path: '/connect/:catrage_id',
  		name: 'connect',
  		component: () => import('../view/connect.vue'), 
  		meta: {
  		  title: '联系我们'
  		}
  		 
  },
  {
  		path: '/list/:catrage_id',
  		name: 'list',
  		component: () => import('../view/list.vue'), 
  		meta: {
  		  title: '列表页'
  		}
  		 
  },

 
  {
  		path: '/list2/:catrage_id',
  		name: 'list2',
  		component: () => import('../view/list2.vue'), 
  		meta: {
  		  title: '列表页'
  		}
  		 
  },
 
  {
  		path: '/img_list/:catrage_id',
  		name: 'img_list',
  		component: () => import('../view/img_list.vue'), 
  		meta: {
  		  title: '图片列表'
  		}
  		 
  },
   {
  		path: '/show/:id',
  		name: 'show',
  		component: () => import('../view/show.vue'), 
  		meta: {
  		  title: '内容详情页'
  		}
  		 
   },
   {
   		path: '/m_list/:catrage_id',
   		name: 'm_list',
   		component: () => import('../view/web/list.vue'), 
   		meta: {
   		  title: '手机端列表页'
   		}
   		 
   },
   {
   		path: '/m_list2/:catrage_id',
   		name: 'm_list2',
   		component: () => import('../view/web/list2.vue'), 
   		meta: {
   		  title: '手机端列表页'
   		}
   		 
   },
   
   {
   		path: '/m_img_list/:catrage_id',
   		name: 'm_img_list',
   		component: () => import('../view/web/img_list.vue'), 
   		meta: {
   		  title: '手机端列表页'
   		}
   		 
   },
   {
   		path: '/m_show/:id',
   		name: 'm_show',
   		component: () => import('../view/web/show.vue'), 
   		meta: {
   		  title: '手机端文章详情'
   		}
   		 
   },
   {
   		path: '/m_show2/:id',
   		name: 'm_show2',
   		component: () => import('../view/web/show2.vue'), 
   		meta: {
   		  title: '手机端文章详情'
   		}
   		 
   },
   {
   		path: '/m_page/:catrage_id',
   		name: 'm_page',
   		component: () => import('../view/web/page.vue'), 
   		meta: {
   		  title: '栏目页面'
   		}
   		 
   },
   
   {
   		path: '/m_connect/:catrage_id',
   		name: 'm_connect',
   		component: () => import('../view/web/connect.vue'), 
   		meta: {
   		  title: '联系我们'
   		}
   		 
   },
   
   
 
 
  
]

 

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

// 全局的路由导航守卫 控制导航的访问权限
router.beforeEach((to, from, next) => {
	 
    document.title = "陕西省老龄事业发展基金会";
    // 设置页面标题
    if(to.meta.title){
        document.title =  document.title + '-'+ to.meta.title
    }else{
		document.title = "陕西省老龄事业发展基金会";
	}
 
	if(isMobile()){
		 if(to.path === '/'){
		    next('/m_index')
		 }
		
	}else{
		 next();
	} 
    
    next()
	
});

 
export default router